import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Trans } from "@hopper-b2b/i18n";
import { useRebookImportantInfo } from "@tenant/flights-rebook";
import { Typography, TypographyTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import { CoreFlightsRebookComponent } from "~core-flights-rebook/components/rebook-component";
import { useFlightsRebookStyles } from "~core-flights-rebook/styles";

const COMPONENT_KEY = CoreFlightsRebookComponent.RebookImportantInfo;

type RebookImportantInfoProps = PlatformComponentProps;

export const RebookImportantInfo = (props: RebookImportantInfoProps) => {
  const styles = useFlightsRebookStyles(COMPONENT_KEY);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className, children } = props;

  const { text } = useRebookImportantInfo(props);

  return (
    <div className={clsx(block, className)}>
      <Typography
        type={TypographyTypeEnum.Heading}
        size="xs"
        weight="light"
        className={cn("title")}
      >
        {text.title}
      </Typography>
      <ol className={cn("info-list")}>
        <Trans
          i18nKey="core-flights.rebook.summary.important-info.items"
          components={{
            item: (
              <Typography
                type={TypographyTypeEnum.Label}
                variant="secondary"
                size="md"
                component="li"
              />
            ),
            bold: <span className={cn("bold")} />,
          }}
          values={{
            supportNumber: text.supportNumber,
            amountCap: text.rebookingAmountCap,
          }}
        />
      </ol>
      {children}
    </div>
  );
};
